module.exports = __webpack_public_path__ + "media/images/ioscor_face-420273c2a2509397a88ffa6f448b5e51.svg";